export const NAME = 'CdbLog';
export const CRUMB_LABEL_KEY = 'ADM_CdbLog';
export { DMS_MODULE } from '../constants';
